import { Dictionary } from "../../fable-library.3.7.17/MutableMap.js";
import { int32ToString, structuralHash, equals } from "../../fable-library.3.7.17/Util.js";
import { addToDict, getItemFromDict } from "../../fable-library.3.7.17/MapUtil.js";
import { Union } from "../../fable-library.3.7.17/Types.js";
import { list_type, tuple_type, class_type, int32_type, float64_type, string_type, union_type } from "../../fable-library.3.7.17/Reflection.js";
import { Html$reflection, Html__Stringify } from "./Html.fs.js";
import { join } from "../../fable-library.3.7.17/String.js";
import { map } from "../../fable-library.3.7.17/List.js";

export const MasterTypeHelpers_cache = new Dictionary([], {
    Equals: equals,
    GetHashCode: structuralHash,
});

export function MasterTypeHelpers_stringifyICssValue(cssValue) {
    if (MasterTypeHelpers_cache.has(cssValue)) {
        return getItemFromDict(MasterTypeHelpers_cache, cssValue);
    }
    else {
        const newValue = cssValue.StringifyCss();
        addToDict(MasterTypeHelpers_cache, cssValue, newValue);
        return newValue;
    }
}

export function MasterTypeHelpers_stringifyICounterValue(cssValue) {
    return cssValue.StringifyCounter();
}

export function MasterTypeHelpers_stringifyIFontFaceValue(cssValue) {
    return cssValue.StringifyFontFace();
}

export class Property_FontFaceProperty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AscentOverride", "DescentOverride", "FontDisplay", "FontFamily", "FontStretch", "FontStyle", "FontWeight", "FontVariant", "FontFeatureSettings", "FontVariationSettings", "LineGapOverride", "SizeAdjust", "Src", "UnicodeRange"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "descent-override";
            }
            case 2: {
                return "font-display";
            }
            case 3: {
                return "font-family";
            }
            case 4: {
                return "font-stretch";
            }
            case 5: {
                return "font-style";
            }
            case 6: {
                return "font-weight";
            }
            case 7: {
                return "font-variant";
            }
            case 8: {
                return "font-feature-settings";
            }
            case 9: {
                return "font-variation-settings";
            }
            case 10: {
                return "line-gap-override";
            }
            case 11: {
                return "size-adjust";
            }
            case 12: {
                return "src";
            }
            case 13: {
                return "unicode-range";
            }
            default: {
                return "ascent-override";
            }
        }
    }
}

export function Property_FontFaceProperty$reflection() {
    return union_type("Fss.Types.Property.FontFaceProperty", [], Property_FontFaceProperty, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class Property_CounterProperty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["System", "Negative", "Prefix", "Suffix", "Range", "Pad", "Fallback", "Symbols", "AdditiveSymbols", "SpeakAs", "NameLabel"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "negative";
            }
            case 2: {
                return "prefix";
            }
            case 3: {
                return "suffix";
            }
            case 4: {
                return "range";
            }
            case 5: {
                return "pad";
            }
            case 6: {
                return "fallback";
            }
            case 7: {
                return "symbols";
            }
            case 8: {
                return "additive-symbols";
            }
            case 9: {
                return "speak-as";
            }
            case 10: {
                return "name-label";
            }
            default: {
                return "system";
            }
        }
    }
}

export function Property_CounterProperty$reflection() {
    return union_type("Fss.Types.Property.CounterProperty", [], Property_CounterProperty, () => [[], [], [], [], [], [], [], [], [], [], []]);
}

export class Property_CssProperty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Appearance", "AlignContent", "AlignItems", "AlignSelf", "All", "AnimationDelay", "AnimationDirection", "AnimationDuration", "AnimationFillMode", "AnimationIterationCount", "AnimationName", "AnimationPlayState", "AnimationTimingFunction", "AspectRatio", "BackfaceVisibility", "BackgroundAttachment", "BackgroundBlendMode", "BackgroundClip", "BackgroundColor", "BackgroundImage", "BackgroundOrigin", "BackgroundPosition", "BackgroundRepeat", "BackgroundSize", "BackdropFilter", "Bleed", "Border", "BorderBottomColor", "BorderBottomLeftRadius", "BorderBottomRightRadius", "BorderBottomStyle", "BorderBottomWidth", "BorderBottom", "BorderCollapse", "BorderColor", "BorderImage", "BorderImageOutset", "BorderImageRepeat", "BorderImageSource", "BorderImageSlice", "BorderImageWidth", "BorderLeftColor", "BorderLeftStyle", "BorderLeftWidth", "BorderLeft", "BorderRadius", "BorderRightColor", "BorderRightStyle", "BorderRightWidth", "BorderRight", "BorderSpacing", "BorderStyle", "BorderTopColor", "BorderTopLeftRadius", "BorderTopRightRadius", "BorderTopStyle", "BorderTopWidth", "BorderTop", "BorderWidth", "BorderBlockColor", "Bottom", "BoxDecorationBreak", "BoxShadow", "BoxSizing", "BreakAfter", "BreakBefore", "BreakInside", "CaptionSide", "CaretColor", "Clear", "Clip", "ClipPath", "Color", "ColorAdjust", "Columns", "ColumnCount", "ColumnFill", "ColumnGap", "ColumnRule", "ColumnRuleColor", "ColumnRuleStyle", "ColumnRuleWidth", "ColumnSpan", "ColumnWidth", "Content", "CounterIncrement", "CounterReset", "CounterSet", "CueAfter", "CueBefore", "Cue", "Cursor", "Direction", "Display", "Elevation", "EmptyCells", "Filter", "Flex", "FlexBasis", "FlexDirection", "FontFeatureSettings", "FontVariationSettings", "FlexFlow", "FlexGrow", "FlexShrink", "FlexWrap", "Float", "FontFamily", "FontKerning", "FontLanguageOverride", "FontSizeAdjust", "FontSize", "FontStretch", "FontStyle", "FontDisplay", "FontSynthesis", "FontVariant", "FontVariantAlternates", "FontVariantCaps", "FontVariantEastAsian", "FontVariantLigatures", "FontVariantNumeric", "FontVariantPosition", "FontWeight", "Font", "GridArea", "GridAutoColumns", "GridAutoFlow", "GridAutoRows", "GridColumnEnd", "GridColumnStart", "GridColumn", "GridGap", "GridRowEnd", "GridRowGap", "GridColumnGap", "GridRowStart", "GridRow", "GridTemplateAreas", "GridTemplateColumns", "GridTemplateRows", "GridTemplate", "Grid", "HangingPunctuation", "Height", "Hyphens", "Isolation", "ImageRendering", "JustifyContent", "JustifyItems", "JustifySelf", "Left", "LetterSpacing", "LineBreak", "LineHeight", "ListStyle", "ListStyleImage", "ListStylePosition", "ListStyleType", "LineGapOverride", "MaskClip", "MaskComposite", "MaskImage", "MaskMode", "MaskOrigin", "MaskPosition", "MaskRepeat", "MaskSize", "MarginBottom", "MarginLeft", "MarginRight", "MarginTop", "Margin", "MarginInlineStart", "MarginInlineEnd", "MarginBlockStart", "MarginBlockEnd", "MarkerOffset", "Marks", "MaxHeight", "MaxWidth", "MinHeight", "MinWidth", "MixBlendMode", "NavUp", "NavDown", "NavLeft", "NavRight", "Opacity", "Order", "Orphans", "OutlineColor", "OutlineOffset", "OutlineStyle", "OutlineWidth", "Outline", "Overflow", "OverflowWrap", "OverflowX", "OverflowY", "ObjectFit", "ObjectPosition", "PaddingBottom", "PaddingLeft", "PaddingRight", "PaddingTop", "Padding", "PaddingInlineStart", "PaddingInlineEnd", "PaddingBlockStart", "PaddingBlockEnd", "Page", "PauseAfter", "PauseBefore", "Pause", "PaintOrder", "PointerEvents", "Perspective", "PerspectiveOrigin", "PitchRange", "Pitch", "PlaceContent", "PlaceItems", "PlaceSelf", "PlayDuring", "Position", "Quotes", "Resize", "RestAfter", "RestBefore", "Rest", "Richness", "Right", "Size", "SpeakHeader", "SpeakNumeral", "SpeakPunctuation", "Src", "Speak", "SpeechRate", "Stress", "ScrollBehavior", "ScrollMarginBottom", "ScrollMarginLeft", "ScrollMarginRight", "ScrollMarginTop", "ScrollMargin", "ScrollPaddingBottom", "ScrollPaddingLeft", "ScrollPaddingRight", "ScrollPaddingTop", "ScrollPadding", "ScrollSnapType", "ScrollSnapAlign", "ScrollSnapStop", "SizeAdjust", "OverscrollBehaviorX", "OverscrollBehaviorY", "TabSize", "TableLayout", "TextAlign", "TextAlignLast", "TextDecoration", "TextDecorationColor", "TextDecorationLine", "TextDecorationThickness", "TextDecorationSkip", "TextDecorationSkipInk", "TextDecorationStyle", "TextIndent", "TextOverflow", "TextShadow", "TextTransform", "TextEmphasis", "TextEmphasisColor", "TextEmphasisPosition", "TextEmphasisStyle", "TextUnderlineOffset", "TextUnderlinePosition", "TextSizeAdjust", "TextOrientation", "TextRendering", "TextJustify", "Top", "Transform", "TransformOrigin", "TransformStyle", "Transition", "TransitionDelay", "TransitionDuration", "TransitionProperty", "TransitionTimingFunction", "UnicodeBidi", "UnicodeRange", "UserSelect", "VerticalAlign", "Visibility", "VoiceBalance", "VoiceDuration", "VoiceFamily", "VoicePitch", "VoiceRange", "VoiceRate", "VoiceStress", "VoiceVolume", "Volume", "WhiteSpace", "Widows", "Width", "WillChange", "WordBreak", "WordSpacing", "WordWrap", "WritingMode", "ZIndex", "Active", "AnyLink", "Blank", "Checked", "Current", "Disabled", "Empty", "Enabled", "FirstChild", "FirstOfType", "Focus", "FocusVisible", "FocusWithin", "Future", "Hover", "Indeterminate", "Invalid", "InRange", "Lang", "LastChild", "LastOfType", "Link", "LocalLink", "NthChild", "NthLastChild", "NthLastOfType", "NthOfType", "OnlyChild", "OnlyOfType", "Optional", "OutOfRange", "Past", "Playing", "Paused", "PlaceholderShown", "ReadOnly", "ReadWrite", "Required", "Root", "Scope", "Target", "TargetWithin", "Valid", "Visited", "UserInvalid", "After", "Before", "FirstLetter", "FirstLine", "Selection", "Marker", "AlignmentBaseline", "BaselineShift", "DominantBaseline", "TextAnchor", "ClipRule", "FloodColor", "FloodOpacity", "LightingColor", "StopColor", "StopOpacity", "ColorInterpolation", "ColorInterpolationFilters", "Label", "Fill", "FillOpacity", "FillRule", "ShapeRendering", "Stroke", "StrokeOpacity", "StrokeDasharray", "StrokeDashoffset", "StrokeLinecap", "StrokeLinejoin", "StrokeMiterlimit", "StrokeWidth", "NameLabel", "AdjacentSibling", "GeneralSibling", "Child", "Descendant", "Custom", "Media"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "align-content";
            }
            case 2: {
                return "align-items";
            }
            case 3: {
                return "align-self";
            }
            case 4: {
                return "all";
            }
            case 5: {
                return "animation-delay";
            }
            case 6: {
                return "animation-direction";
            }
            case 7: {
                return "animation-duration";
            }
            case 8: {
                return "animation-fill-mode";
            }
            case 9: {
                return "animation-iteration-count";
            }
            case 10: {
                return "animation-name";
            }
            case 11: {
                return "animation-play-state";
            }
            case 12: {
                return "animation-timing-function";
            }
            case 13: {
                return "aspect-ratio";
            }
            case 14: {
                return "backface-visibility";
            }
            case 15: {
                return "background-attachment";
            }
            case 16: {
                return "background-blend-mode";
            }
            case 17: {
                return "background-clip";
            }
            case 18: {
                return "background-color";
            }
            case 19: {
                return "background-image";
            }
            case 20: {
                return "background-origin";
            }
            case 21: {
                return "background-position";
            }
            case 22: {
                return "background-repeat";
            }
            case 23: {
                return "background-size";
            }
            case 24: {
                return "backdrop-filter";
            }
            case 25: {
                return "bleed";
            }
            case 26: {
                return "border";
            }
            case 27: {
                return "border-bottom-color";
            }
            case 28: {
                return "border-bottom-left-radius";
            }
            case 29: {
                return "border-bottom-right-radius";
            }
            case 30: {
                return "border-bottom-style";
            }
            case 31: {
                return "border-bottom-width";
            }
            case 32: {
                return "border-bottom";
            }
            case 33: {
                return "border-collapse";
            }
            case 34: {
                return "border-color";
            }
            case 35: {
                return "border-image";
            }
            case 36: {
                return "border-image-outset";
            }
            case 37: {
                return "border-image-repeat";
            }
            case 38: {
                return "border-image-source";
            }
            case 39: {
                return "border-image-slice";
            }
            case 40: {
                return "border-image-width";
            }
            case 41: {
                return "border-left-color";
            }
            case 42: {
                return "border-left-style";
            }
            case 43: {
                return "border-left-width";
            }
            case 44: {
                return "border-left";
            }
            case 45: {
                return "border-radius";
            }
            case 46: {
                return "border-right-color";
            }
            case 47: {
                return "border-right-style";
            }
            case 48: {
                return "border-right-width";
            }
            case 49: {
                return "border-right";
            }
            case 50: {
                return "border-spacing";
            }
            case 51: {
                return "border-style";
            }
            case 52: {
                return "border-top-color";
            }
            case 53: {
                return "border-top-left-radius";
            }
            case 54: {
                return "border-top-right-radius";
            }
            case 55: {
                return "border-top-style";
            }
            case 56: {
                return "border-top-width";
            }
            case 57: {
                return "border-top";
            }
            case 58: {
                return "border-width";
            }
            case 59: {
                return "border-block-color";
            }
            case 60: {
                return "bottom";
            }
            case 61: {
                return "box-decoration-break";
            }
            case 62: {
                return "box-shadow";
            }
            case 63: {
                return "box-sizing";
            }
            case 64: {
                return "break-after";
            }
            case 65: {
                return "break-before";
            }
            case 66: {
                return "break-inside";
            }
            case 67: {
                return "caption-side";
            }
            case 68: {
                return "caret-color";
            }
            case 69: {
                return "clear";
            }
            case 70: {
                return "clip";
            }
            case 71: {
                return "clip-path";
            }
            case 72: {
                return "color";
            }
            case 73: {
                return "color-adjust";
            }
            case 74: {
                return "columns";
            }
            case 75: {
                return "column-count";
            }
            case 76: {
                return "column-fill";
            }
            case 77: {
                return "column-gap";
            }
            case 78: {
                return "column-rule";
            }
            case 79: {
                return "column-rule-color";
            }
            case 80: {
                return "column-rule-style";
            }
            case 81: {
                return "column-rule-width";
            }
            case 82: {
                return "column-span";
            }
            case 83: {
                return "column-width";
            }
            case 84: {
                return "content";
            }
            case 85: {
                return "counter-increment";
            }
            case 86: {
                return "counter-reset";
            }
            case 87: {
                return "counter-set";
            }
            case 88: {
                return "cue-after";
            }
            case 89: {
                return "cue-before";
            }
            case 90: {
                return "cue";
            }
            case 91: {
                return "cursor";
            }
            case 92: {
                return "direction";
            }
            case 93: {
                return "display";
            }
            case 94: {
                return "elevation";
            }
            case 95: {
                return "empty-cells";
            }
            case 96: {
                return "filter";
            }
            case 97: {
                return "flex";
            }
            case 98: {
                return "flex-basis";
            }
            case 99: {
                return "flex-direction";
            }
            case 100: {
                return "font-feature-settings";
            }
            case 101: {
                return "font-variation-settings";
            }
            case 102: {
                return "flex-flow";
            }
            case 103: {
                return "flex-grow";
            }
            case 104: {
                return "flex-shrink";
            }
            case 105: {
                return "flex-wrap";
            }
            case 106: {
                return "float";
            }
            case 107: {
                return "font-family";
            }
            case 108: {
                return "font-kerning";
            }
            case 109: {
                return "font-language-override";
            }
            case 110: {
                return "font-size-adjust";
            }
            case 111: {
                return "font-size";
            }
            case 112: {
                return "font-stretch";
            }
            case 113: {
                return "font-style";
            }
            case 114: {
                return "font-display";
            }
            case 115: {
                return "font-synthesis";
            }
            case 116: {
                return "font-variant";
            }
            case 117: {
                return "font-variant-alternates";
            }
            case 118: {
                return "font-variant-caps";
            }
            case 119: {
                return "font-variant-east-asian";
            }
            case 120: {
                return "font-variant-ligatures";
            }
            case 121: {
                return "font-variant-numeric";
            }
            case 122: {
                return "font-variant-position";
            }
            case 123: {
                return "font-weight";
            }
            case 124: {
                return "font";
            }
            case 125: {
                return "grid-area";
            }
            case 126: {
                return "grid-auto-columns";
            }
            case 127: {
                return "grid-auto-flow";
            }
            case 128: {
                return "grid-auto-rows";
            }
            case 129: {
                return "grid-column-end";
            }
            case 130: {
                return "grid-column-start";
            }
            case 131: {
                return "grid-column";
            }
            case 132: {
                return "grid-gap";
            }
            case 133: {
                return "grid-row-end";
            }
            case 134: {
                return "grid-row-gap";
            }
            case 135: {
                return "grid-column-gap";
            }
            case 136: {
                return "grid-row-start";
            }
            case 137: {
                return "grid-row";
            }
            case 138: {
                return "grid-template-areas";
            }
            case 139: {
                return "grid-template-columns";
            }
            case 140: {
                return "grid-template-rows";
            }
            case 141: {
                return "grid-template";
            }
            case 142: {
                return "grid";
            }
            case 143: {
                return "hanging-punctuation";
            }
            case 144: {
                return "height";
            }
            case 145: {
                return "hyphens";
            }
            case 146: {
                return "isolation";
            }
            case 147: {
                return "image-rendering";
            }
            case 148: {
                return "justify-content";
            }
            case 149: {
                return "justify-items";
            }
            case 150: {
                return "justify-self";
            }
            case 151: {
                return "left";
            }
            case 152: {
                return "letter-spacing";
            }
            case 153: {
                return "line-break";
            }
            case 154: {
                return "line-height";
            }
            case 155: {
                return "list-style";
            }
            case 156: {
                return "list-style-image";
            }
            case 157: {
                return "list-style-position";
            }
            case 158: {
                return "list-style-type";
            }
            case 159: {
                return "line-gap-override";
            }
            case 160: {
                return "mask-clip";
            }
            case 161: {
                return "mask-composite";
            }
            case 162: {
                return "mask-image";
            }
            case 163: {
                return "mask-mode";
            }
            case 164: {
                return "mask-origin";
            }
            case 165: {
                return "mask-position";
            }
            case 166: {
                return "mask-repeat";
            }
            case 167: {
                return "mask-size";
            }
            case 168: {
                return "margin-bottom";
            }
            case 169: {
                return "margin-left";
            }
            case 170: {
                return "margin-right";
            }
            case 171: {
                return "margin-top";
            }
            case 172: {
                return "margin";
            }
            case 173: {
                return "margin-inline-start";
            }
            case 174: {
                return "margin-inline-end";
            }
            case 175: {
                return "margin-block-start";
            }
            case 176: {
                return "margin-block-end";
            }
            case 177: {
                return "marker-offset";
            }
            case 178: {
                return "marks";
            }
            case 179: {
                return "max-height";
            }
            case 180: {
                return "max-width";
            }
            case 181: {
                return "min-height";
            }
            case 182: {
                return "min-width";
            }
            case 183: {
                return "mix-blend-mode";
            }
            case 184: {
                return "nav-up";
            }
            case 185: {
                return "nav-down";
            }
            case 186: {
                return "nav-left";
            }
            case 187: {
                return "nav-right";
            }
            case 188: {
                return "opacity";
            }
            case 189: {
                return "order";
            }
            case 190: {
                return "orphans";
            }
            case 191: {
                return "outline-color";
            }
            case 192: {
                return "outline-offset";
            }
            case 193: {
                return "outline-style";
            }
            case 194: {
                return "outline-width";
            }
            case 195: {
                return "outline";
            }
            case 196: {
                return "overflow";
            }
            case 197: {
                return "overflow-wrap";
            }
            case 198: {
                return "overflow-x";
            }
            case 199: {
                return "overflow-y";
            }
            case 200: {
                return "object-fit";
            }
            case 201: {
                return "object-position";
            }
            case 202: {
                return "padding-bottom";
            }
            case 203: {
                return "padding-left";
            }
            case 204: {
                return "padding-right";
            }
            case 205: {
                return "padding-top";
            }
            case 206: {
                return "padding";
            }
            case 207: {
                return "padding-inline-start";
            }
            case 208: {
                return "padding-inline-end";
            }
            case 209: {
                return "padding-block-start";
            }
            case 210: {
                return "padding-block-end";
            }
            case 211: {
                return "page";
            }
            case 212: {
                return "pause-after";
            }
            case 213: {
                return "pause-before";
            }
            case 214: {
                return "pause";
            }
            case 215: {
                return "paint-order";
            }
            case 216: {
                return "pointer-events";
            }
            case 217: {
                return "perspective";
            }
            case 218: {
                return "perspective-origin";
            }
            case 219: {
                return "pitch-range";
            }
            case 220: {
                return "pitch";
            }
            case 221: {
                return "place-content";
            }
            case 222: {
                return "place-items";
            }
            case 223: {
                return "place-self";
            }
            case 224: {
                return "play-during";
            }
            case 225: {
                return "position";
            }
            case 226: {
                return "quotes";
            }
            case 227: {
                return "resize";
            }
            case 228: {
                return "rest-after";
            }
            case 229: {
                return "rest-before";
            }
            case 230: {
                return "rest";
            }
            case 231: {
                return "richness";
            }
            case 232: {
                return "right";
            }
            case 233: {
                return "size";
            }
            case 234: {
                return "speak-header";
            }
            case 235: {
                return "speak-numeral";
            }
            case 236: {
                return "speak-punctuation";
            }
            case 237: {
                return "src";
            }
            case 238: {
                return "speak";
            }
            case 239: {
                return "speech-rate";
            }
            case 240: {
                return "stress";
            }
            case 241: {
                return "scroll-behavior";
            }
            case 242: {
                return "scroll-margin-bottom";
            }
            case 243: {
                return "scroll-margin-left";
            }
            case 244: {
                return "scroll-margin-right";
            }
            case 245: {
                return "scroll-margin-top";
            }
            case 246: {
                return "scroll-margin";
            }
            case 247: {
                return "scroll-padding-bottom";
            }
            case 248: {
                return "scroll-padding-left";
            }
            case 249: {
                return "scroll-padding-right";
            }
            case 250: {
                return "scroll-padding-top";
            }
            case 251: {
                return "scroll-padding";
            }
            case 252: {
                return "scroll-snap-type";
            }
            case 253: {
                return "scroll-snap-align";
            }
            case 254: {
                return "scroll-snap-stop";
            }
            case 255: {
                return "size-adjust";
            }
            case 256: {
                return "overscroll-behavior-x";
            }
            case 257: {
                return "overscroll-behavior-y";
            }
            case 258: {
                return "tab-size";
            }
            case 259: {
                return "table-layout";
            }
            case 260: {
                return "text-align";
            }
            case 261: {
                return "text-align-last";
            }
            case 262: {
                return "text-decoration";
            }
            case 263: {
                return "text-decoration-color";
            }
            case 264: {
                return "text-decoration-line";
            }
            case 265: {
                return "text-decoration-thickness";
            }
            case 266: {
                return "text-decoration-skip";
            }
            case 267: {
                return "text-decoration-skip-ink";
            }
            case 268: {
                return "text-decoration-style";
            }
            case 269: {
                return "text-indent";
            }
            case 270: {
                return "text-overflow";
            }
            case 271: {
                return "text-shadow";
            }
            case 272: {
                return "text-transform";
            }
            case 273: {
                return "text-emphasis";
            }
            case 274: {
                return "text-emphasis-color";
            }
            case 275: {
                return "text-emphasis-position";
            }
            case 276: {
                return "text-emphasis-style";
            }
            case 277: {
                return "text-underline-offset";
            }
            case 278: {
                return "text-underline-position";
            }
            case 279: {
                return "text-size-adjust";
            }
            case 280: {
                return "text-orientation";
            }
            case 281: {
                return "text-rendering";
            }
            case 282: {
                return "text-justify";
            }
            case 283: {
                return "top";
            }
            case 284: {
                return "transform";
            }
            case 285: {
                return "transform-origin";
            }
            case 286: {
                return "transform-style";
            }
            case 287: {
                return "transition";
            }
            case 288: {
                return "transition-delay";
            }
            case 289: {
                return "transition-duration";
            }
            case 290: {
                return "transition-property";
            }
            case 291: {
                return "transition-timing-function";
            }
            case 292: {
                return "unicode-bidi";
            }
            case 293: {
                return "unicode-range";
            }
            case 294: {
                return "user-select";
            }
            case 295: {
                return "vertical-align";
            }
            case 296: {
                return "visibility";
            }
            case 297: {
                return "voice-balance";
            }
            case 298: {
                return "voice-duration";
            }
            case 299: {
                return "voice-family";
            }
            case 300: {
                return "voice-pitch";
            }
            case 301: {
                return "voice-range";
            }
            case 302: {
                return "voice-rate";
            }
            case 303: {
                return "voice-stress";
            }
            case 304: {
                return "voice-colume";
            }
            case 305: {
                return "volume";
            }
            case 306: {
                return "white-space";
            }
            case 307: {
                return "widows";
            }
            case 308: {
                return "width";
            }
            case 309: {
                return "will-change";
            }
            case 310: {
                return "word-break";
            }
            case 311: {
                return "word-spacing";
            }
            case 312: {
                return "word-wrap";
            }
            case 313: {
                return "writing-mode";
            }
            case 314: {
                return "z-index";
            }
            case 315: {
                return "active";
            }
            case 316: {
                return "any-link";
            }
            case 317: {
                return "blank";
            }
            case 318: {
                return "checked";
            }
            case 319: {
                return "current";
            }
            case 320: {
                return "disabled";
            }
            case 321: {
                return "empty";
            }
            case 322: {
                return "enabled";
            }
            case 323: {
                return "first-child";
            }
            case 324: {
                return "first-of-type";
            }
            case 325: {
                return "focus";
            }
            case 326: {
                return "focus-visible";
            }
            case 327: {
                return "focus-within";
            }
            case 328: {
                return "future";
            }
            case 329: {
                return "hover";
            }
            case 330: {
                return "indeterminate";
            }
            case 331: {
                return "invalid";
            }
            case 332: {
                return "in-range";
            }
            case 334: {
                return "last-child";
            }
            case 335: {
                return "last-of-type";
            }
            case 336: {
                return "link";
            }
            case 337: {
                return "local-link";
            }
            case 342: {
                return "only-child";
            }
            case 343: {
                return "only-of-type";
            }
            case 344: {
                return "optional";
            }
            case 345: {
                return "out-of-range";
            }
            case 346: {
                return "past";
            }
            case 347: {
                return "playing";
            }
            case 348: {
                return "paused";
            }
            case 349: {
                return "placeholder-shown";
            }
            case 350: {
                return "read-only";
            }
            case 351: {
                return "read-write";
            }
            case 352: {
                return "required";
            }
            case 353: {
                return "root";
            }
            case 354: {
                return "scope";
            }
            case 355: {
                return "target";
            }
            case 356: {
                return "target-within";
            }
            case 357: {
                return "valid";
            }
            case 358: {
                return "visited";
            }
            case 359: {
                return "user-invalid";
            }
            case 360: {
                return "after";
            }
            case 361: {
                return "before";
            }
            case 362: {
                return "first-letter";
            }
            case 363: {
                return "first-line";
            }
            case 364: {
                return "selection";
            }
            case 365: {
                return "marker";
            }
            case 366: {
                return "alignment-baseline";
            }
            case 367: {
                return "baseline-shift";
            }
            case 368: {
                return "dominant-baseline";
            }
            case 369: {
                return "text-anchor";
            }
            case 370: {
                return "clip-rule";
            }
            case 371: {
                return "flood-color";
            }
            case 372: {
                return "flood-opacity";
            }
            case 373: {
                return "lighting-color";
            }
            case 374: {
                return "stop-color";
            }
            case 375: {
                return "stop-opacity";
            }
            case 376: {
                return "color-interpolation";
            }
            case 377: {
                return "color-interpolation-filters";
            }
            case 378: {
                return "label";
            }
            case 379: {
                return "fill";
            }
            case 380: {
                return "fill-opacity";
            }
            case 381: {
                return "fill-rule";
            }
            case 382: {
                return "shape-rendering";
            }
            case 383: {
                return "stroke";
            }
            case 384: {
                return "stroke-opacity";
            }
            case 385: {
                return "stroke-dasharray";
            }
            case 386: {
                return "stroke-dashoffset";
            }
            case 387: {
                return "stroke-linecap";
            }
            case 388: {
                return "stroke-linejoin";
            }
            case 389: {
                return "stroke-miterlimit";
            }
            case 390: {
                return "stroke-width";
            }
            case 333: {
                return `lang(${this$.fields[0]})`;
            }
            case 338: {
                return `nth-child(${this$.fields[0]})`;
            }
            case 339: {
                return `nth-last-child(${this$.fields[0]})`;
            }
            case 341: {
                return `nth-of-type(${this$.fields[0]})`;
            }
            case 340: {
                return `nth-last-of-type(${this$.fields[0]})`;
            }
            case 392: {
                return ` + ${Html__Stringify(this$.fields[0])}`;
            }
            case 393: {
                return ` ~ ${Html__Stringify(this$.fields[0])}`;
            }
            case 394: {
                return ` > ${Html__Stringify(this$.fields[0])}`;
            }
            case 395: {
                return ` ${Html__Stringify(this$.fields[0])}`;
            }
            case 396: {
                return this$.fields[0].toLocaleLowerCase();
            }
            case 397: {
                return "media";
            }
            case 391: {
                return "name-label";
            }
            default: {
                return "appearance";
            }
        }
    }
}

export function Property_CssProperty$reflection() {
    return union_type("Fss.Types.Property.CssProperty", [], Property_CssProperty, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [["Item", string_type]], [], [], [], [], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [["Item", Html$reflection()]], [["Item", Html$reflection()]], [["Item", Html$reflection()]], [["Item", Html$reflection()]], [["Item", string_type]], []]);
}

export class None$0027 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["None\u0027"];
    }
    StringifyCss() {
        return "none";
    }
}

export function None$0027$reflection() {
    return union_type("Fss.Types.None\u0027", [], None$0027, () => [[]]);
}

export class Auto extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Auto"];
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCounter() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        return "auto";
    }
}

export function Auto$reflection() {
    return union_type("Fss.Types.Auto", [], Auto, () => [[]]);
}

export class Normal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Normal"];
    }
    StringifyCss() {
        return "normal";
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
}

export function Normal$reflection() {
    return union_type("Fss.Types.Normal", [], Normal, () => [[]]);
}

export class Float extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Float"];
    }
    StringifyCss() {
        const this$ = this;
        return this$.fields[0].toString();
    }
}

export function Float$reflection() {
    return union_type("Fss.Types.Float", [], Float, () => [[["Item", float64_type]]]);
}

export class Int extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Int"];
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        const this$ = this;
        return int32ToString(this$.fields[0]);
    }
}

export function Int$reflection() {
    return union_type("Fss.Types.Int", [], Int, () => [[["Item", int32_type]]]);
}

export class Char extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Char"];
    }
    StringifyCss() {
        const this$ = this;
        return `'${this$.fields[0]}'`;
    }
}

export function Char$reflection() {
    return union_type("Fss.Types.Char", [], Char, () => [[["Item", string_type]]]);
}

export class String$ extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String"];
    }
    StringifyCounter() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        const this$ = this;
        return this$.fields[0];
    }
}

export function String$$reflection() {
    return union_type("Fss.Types.String", [], String$, () => [[["Item", string_type]]]);
}

export class Stringed extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Stringed"];
    }
    StringifyFontFace() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCounter() {
        const this$ = this;
        return MasterTypeHelpers_stringifyICssValue(this$);
    }
    StringifyCss() {
        const this$ = this;
        return `"${this$.fields[0]}"`;
    }
}

export function Stringed$reflection() {
    return union_type("Fss.Types.Stringed", [], Stringed, () => [[["Item", string_type]]]);
}

export class NameLabel extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NameLabel"];
    }
    StringifyCss() {
        const this$ = this;
        return NameLabel__Unwrap(this$);
    }
    StringifyCounter() {
        const this$ = this;
        return NameLabel__Unwrap(this$);
    }
}

export function NameLabel$reflection() {
    return union_type("Fss.Types.NameLabel", [], NameLabel, () => [[["Item", string_type]]]);
}

export function NameLabel__Unwrap(this$) {
    return this$.fields[0];
}

export class CssRule {
    constructor(property) {
        this.property = property;
    }
}

export function CssRule$reflection() {
    return class_type("Fss.Types.CssRule", void 0, CssRule);
}

export function CssRule_$ctor_Z207A3CFB(property) {
    return new CssRule(property);
}

export class Keywords extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Inherit", "Initial", "Unset", "Revert"];
    }
    StringifyCss() {
        const this$ = this;
        switch (this$.tag) {
            case 1: {
                return "initial";
            }
            case 2: {
                return "unset";
            }
            case 3: {
                return "revert";
            }
            default: {
                return "inherit";
            }
        }
    }
}

export function Keywords$reflection() {
    return union_type("Fss.Types.Keywords", [], Keywords, () => [[], [], [], []]);
}

export function CssRule__value_Z61D3073E(this$, keyword) {
    const tupledArg = [this$.property, keyword];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRule__get_initial(this$) {
    const tupledArg = [this$.property, new Keywords(1)];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRule__get_inherit$0027(this$) {
    const tupledArg = [this$.property, new Keywords(0)];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRule__get_unset(this$) {
    const tupledArg = [this$.property, new Keywords(2)];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRule__get_revert(this$) {
    const tupledArg = [this$.property, new Keywords(3)];
    return [tupledArg[0], tupledArg[1]];
}

export class ImportantMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ImportantMaster"];
    }
    StringifyCss() {
        const this$ = this;
        return `${MasterTypeHelpers_stringifyICssValue(this$.fields[0])} !important`;
    }
}

export function ImportantMaster$reflection() {
    return union_type("Fss.Types.ImportantMaster", [], ImportantMaster, () => [[["Item", class_type("Fss.Types.ICssValue")]]]);
}

export class Pseudo extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PseudoClassMaster", "PseudoElementMaster"];
    }
    StringifyCss() {
        const this$ = this;
        if (this$.tag === 1) {
            const ps_3 = join("; ", map((tupledArg_1) => (`${MasterTypeHelpers_stringifyICssValue(tupledArg_1[0])}: ${tupledArg_1[1].StringifyCss()}`), this$.fields[0]));
            return `${ps_3}`;
        }
        else {
            const ps_1 = join("; ", map((tupledArg) => (`${MasterTypeHelpers_stringifyICssValue(tupledArg[0])}: ${tupledArg[1].StringifyCss()}`), this$.fields[0]));
            return `${ps_1}`;
        }
    }
}

export function Pseudo$reflection() {
    return union_type("Fss.Types.Pseudo", [], Pseudo, () => [[["Item", list_type(tuple_type(Property_CssProperty$reflection(), class_type("Fss.Types.ICssValue")))]], [["Item", list_type(tuple_type(Property_CssProperty$reflection(), class_type("Fss.Types.ICssValue")))]]]);
}

export function Pseudo__Unwrap(this$) {
    if (this$.tag === 1) {
        return this$.fields[0];
    }
    else {
        return this$.fields[0];
    }
}

export class CombinatorMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CombinatorMaster"];
    }
    StringifyCss() {
        return "";
    }
}

export function CombinatorMaster$reflection() {
    return union_type("Fss.Types.CombinatorMaster", [], CombinatorMaster, () => [[["Item", list_type(tuple_type(Property_CssProperty$reflection(), class_type("Fss.Types.ICssValue")))]]]);
}

export function CombinatorMaster__Unwrap(this$) {
    return this$.fields[0];
}

export class DividerMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DividerMaster"];
    }
    StringifyCss() {
        const this$ = this;
        return `${this$.fields[0]} / ${this$.fields[1]}`;
    }
}

export function DividerMaster$reflection() {
    return union_type("Fss.Types.DividerMaster", [], DividerMaster, () => [[["Item1", string_type], ["Item2", string_type]]]);
}

export class UrlMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UrlMaster"];
    }
    StringifyFontFace() {
        const this$ = this;
        return this$.StringifyCss();
    }
    StringifyCounter() {
        const this$ = this;
        return this$.StringifyCss();
    }
    StringifyCss() {
        const this$ = this;
        return `url(${this$.fields[0]})`;
    }
}

export function UrlMaster$reflection() {
    return union_type("Fss.Types.UrlMaster", [], UrlMaster, () => [[["Item", string_type]]]);
}

export class CustomMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CustomMaster"];
    }
    StringifyCss() {
        const this$ = this;
        return this$.fields[0];
    }
}

export function CustomMaster$reflection() {
    return union_type("Fss.Types.CustomMaster", [], CustomMaster, () => [[["Item", string_type]]]);
}

export class PathMaster extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PathMaster"];
    }
    StringifyCss() {
        const this$ = this;
        return `path('${this$.fields[0]}')`;
    }
}

export function PathMaster$reflection() {
    return union_type("Fss.Types.PathMaster", [], PathMaster, () => [[["Item", string_type]]]);
}

export class CssRuleWithAuto extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function CssRuleWithAuto$reflection() {
    return class_type("Fss.Types.CssRuleWithAuto", void 0, CssRuleWithAuto, CssRule$reflection());
}

export function CssRuleWithAuto_$ctor_Z207A3CFB(property) {
    return new CssRuleWithAuto(property);
}

export function CssRuleWithAuto__get_auto(this$) {
    const tupledArg = [this$.property_1, new Auto(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithNone extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function CssRuleWithNone$reflection() {
    return class_type("Fss.Types.CssRuleWithNone", void 0, CssRuleWithNone, CssRule$reflection());
}

export function CssRuleWithNone_$ctor_Z207A3CFB(property) {
    return new CssRuleWithNone(property);
}

export function CssRuleWithNone__get_none(this$) {
    const tupledArg = [this$.property_1, new None$0027(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithAutoNone extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function CssRuleWithAutoNone$reflection() {
    return class_type("Fss.Types.CssRuleWithAutoNone", void 0, CssRuleWithAutoNone, CssRule$reflection());
}

export function CssRuleWithAutoNone_$ctor_Z207A3CFB(property) {
    return new CssRuleWithAutoNone(property);
}

export function CssRuleWithAutoNone__get_auto(this$) {
    const tupledArg = [this$.property_1, new Auto(0)];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRuleWithAutoNone__get_none(this$) {
    const tupledArg = [this$.property_1, new None$0027(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithNormal extends CssRule {
    constructor(property) {
        super(property);
        this.property_1 = property;
    }
}

export function CssRuleWithNormal$reflection() {
    return class_type("Fss.Types.CssRuleWithNormal", void 0, CssRuleWithNormal, CssRule$reflection());
}

export function CssRuleWithNormal_$ctor_Z207A3CFB(property) {
    return new CssRuleWithNormal(property);
}

export function CssRuleWithNormal__get_normal(this$) {
    const tupledArg = [this$.property_1, new Normal(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithNormalNone extends CssRuleWithNormal {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function CssRuleWithNormalNone$reflection() {
    return class_type("Fss.Types.CssRuleWithNormalNone", void 0, CssRuleWithNormalNone, CssRuleWithNormal$reflection());
}

export function CssRuleWithNormalNone_$ctor_Z207A3CFB(property) {
    return new CssRuleWithNormalNone(property);
}

export function CssRuleWithNormalNone__get_none(this$) {
    const tupledArg = [this$.property_2, new None$0027(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithAutoNormal extends CssRuleWithAuto {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function CssRuleWithAutoNormal$reflection() {
    return class_type("Fss.Types.CssRuleWithAutoNormal", void 0, CssRuleWithAutoNormal, CssRuleWithAuto$reflection());
}

export function CssRuleWithAutoNormal_$ctor_Z207A3CFB(property) {
    return new CssRuleWithAutoNormal(property);
}

export function CssRuleWithAutoNormal__get_normal(this$) {
    const tupledArg = [this$.property_2, new Normal(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithAutoNormalNone extends CssRuleWithAutoNone {
    constructor(property) {
        super(property);
        this.property_2 = property;
    }
}

export function CssRuleWithAutoNormalNone$reflection() {
    return class_type("Fss.Types.CssRuleWithAutoNormalNone", void 0, CssRuleWithAutoNormalNone, CssRuleWithAutoNone$reflection());
}

export function CssRuleWithAutoNormalNone_$ctor_Z207A3CFB(property) {
    return new CssRuleWithAutoNormalNone(property);
}

export function CssRuleWithAutoNormalNone__get_normal(this$) {
    const tupledArg = [this$.property_2, new Normal(0)];
    return [tupledArg[0], tupledArg[1]];
}

export class CssRuleWithValueFunctions$1 extends CssRule {
    constructor(property, seperator) {
        super(property);
        this.property_1 = property;
        this.seperator = seperator;
    }
}

export function CssRuleWithValueFunctions$1$reflection(gen0) {
    return class_type("Fss.Types.CssRuleWithValueFunctions`1", [gen0], CssRuleWithValueFunctions$1, CssRule$reflection());
}

export function CssRuleWithValueFunctions$1_$ctor_5DDD5F9E(property, seperator) {
    return new CssRuleWithValueFunctions$1(property, seperator);
}

export function CssRuleWithValueFunctions$1__value_2B595(this$, value) {
    const tupledArg = [this$.property_1, new String$(0, MasterTypeHelpers_stringifyICssValue(value))];
    return [tupledArg[0], tupledArg[1]];
}

export function CssRuleWithValueFunctions$1__value_Z38D79C61(this$, values) {
    const tupledArg = [this$.property_1, new String$(0, join(this$.seperator, map(MasterTypeHelpers_stringifyICssValue, values)))];
    return [tupledArg[0], tupledArg[1]];
}

